import React, { useEffect, useState } from 'react';
import TableHeading from "../../components/common/TableHeading";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import MultiSelectDropdown from "../../components/common/MultiSelectDropdown";
import Loginbtn from "../../components/common/loginbtn";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import {
  addEmployeeAssigneAssisment,
  getAllAssignedEmployee,
  getAllAssignedEmployeeByCompanyId,
  getAllAssignEmployeesByCampaignId,
  getAllCompanies,
  getAllEmployee,
  getAllModels,
  getAssessorsEmployeeList
} from '../../../services/api-services';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes/url-constant';
import { handleFormInput } from '../../../utills/formutilities';
import moment from 'moment';
import { ErrorMsg } from '../../../utills/error-message-constant';
import NewMultiSelectDropdown from '../../components/common/NewMultiSelectDropdown';

const AddAssignedAssesments = () => {

  const today = new Date().toISOString().split("T")[0];
  const location = useLocation();

  const [companyList, setCompanyList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");

  // const [selectedOptions, setSelectedOptions] = useState([]);
  const [Employeebtndisable, setEmployeebtndisable] = useState(false);
  const [EmployeebtnLoader, setEmployeebtnLoader] = useState(false);
  // const [selectOnlineOption, setSelectOnlineOption] = useState([]);
  // const [selectOnlineUser, setSelectOnlineUser] = useState([]);


  const [selectModelList, setSelectModelList] = useState([]);
  const [formError, setFormError] = useState({});
  let navigate = useNavigate();
  let EditData = ""
  if (location?.state?.pageType == "Edit") {
    EditData = (location?.state?.Data || null)
  }
  const [selectedCompanyId, setSelectedCompanyId] = useState(EditData?.companyResponse?.id || "");
  const [modalName, setModalName] = useState(EditData?.companyResponse?.id ? EditData?.companyResponse?.modelResponse?.modelName : "")
  // ---------------- DROPDOWN STATES ----------------
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeSearchText, setEmployeeSearchText] = useState("");
  const [employeePageIndex, setEmployeePageIndex] = useState(0);
  const [employeeHasMore, setEmployeeHasMore] = useState(true);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  const [assessorOptions, setAssessorOptions] = useState([]);
  const [selectedAssessors, setSelectedAssessors] = useState([]);
  const [assessorSearchText, setAssessorSearchText] = useState("");
  const [assessorPageIndex, setAssessorPageIndex] = useState(0);
  const [assessorHasMore, setAssessorHasMore] = useState(true);
  const [assessorLoading, setAssessorLoading] = useState(false);
  // Assigned Employees state
  // const [assignedEmployeeList, setAssignedEmployeeList] = useState([]);
  // const [assignedEmployeeLoading, setAssignedEmployeeLoading] = useState(false);

  const [assignedEmployees, setAssignedEmployees] = useState([]);
  const [assignedAssessors, setAssignedAssessors] = useState([]);
  const [payload, setPayload] = useState({
    id: EditData?.id || "",
    employeeList: "",
    title: EditData?.title || "",
    modelId: EditData?.companyResponse?.modelResponse?.id || "",
    companyId: EditData?.companyResponse?.id || "",
    durationFromDate: EditData?.durationFromDate
      ? moment.utc(EditData?.durationFromDate).format("YYYY-MM-DDT00:00:00.000[Z]")
      : "",
    durationToDate: EditData?.durationToDate
      ? moment.utc(EditData?.durationToDate).format("YYYY-MM-DDT00:00:00.000[Z]")
      : "",
    companyColorRequestPayloadList: [
      { id: "", colorName: "#D42327", rangeFrom: '0', rangeTo: "20" },
      { id: "", colorName: "#fd8000", rangeFrom: '20', rangeTo: "40" },
      { id: "", colorName: "#ffbf01", rangeFrom: '40', rangeTo: "50" },
      { id: "", colorName: "#dbc51a", rangeFrom: '50', rangeTo: "60" },
      { id: "", colorName: "#92d14e", rangeFrom: '60', rangeTo: "80" },
      { id: "", colorName: "#557D39", rangeFrom: '80', rangeTo: "100" },
    ]
  });

  useEffect(() => {
    if (location?.state?.pageType == "Edit") {
      const data = location.state?.Data;
      setPayload({
        ...payload,
        companyColorRequestPayloadList: data.companyColorList?.map((item, index) => ({
          ...item,
          rangeFrom: index === 0 ? "0" : item.rangeFrom ?? "",
        })) || [],
      });
    }
  }, [location.state]);

  // Get all companies and map them into options
  const getallCompany = async (status) => {
    try {
      const response = await getAllCompanies(status);
      if (response?.data?.responseCode === 404) {
        // Handle no companies if necessary
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          Status: data?.status,
          modelName: data?.modelResponse?.modelName
        }));
        setCompanyList(companyOptions);

      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };


  useEffect(() => {
    getallCompany(1);
  }, []);


  const handleSelectCompany = (e) => {
    const selectedCompany = companyList?.find(
      (company) => company.value === e.target.value
    );

    setSelectedCompanyId(e.target.value);
    setPayload(prev => ({ ...prev, companyId: e.target.value }));

    setAssessorOptions([]);
    setSelectedAssessors([]);
    setEmployeeOptions([]);
    setSelectedEmployees([]);

    // setAssignedAssessors([]);
  };

  // Handle input changes including validation for dates  
  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "durationFromDate" || name === "durationToDate") {
      if (value) {
        // Convert to UTC format: YYYY-MM-DDT00:00:00.000Z
        formattedValue = moment.utc(value, "YYYY-MM-DD").format("YYYY-MM-DDT00:00:00.000[Z]");
      }
      const fromDate = payload.durationFromDate;
      const toDate = payload.durationToDate;
      if (name === "durationFromDate") {
        if (toDate && moment(formattedValue).isAfter(moment(toDate))) {
          setFormError(prev => ({
            ...prev,
            durationFromDate: "Duration From cannot be later than Duration To.",
          }));
          setPayload(prev => ({ ...prev, durationFromDate: "" }));
          return;
        } else if (!moment(formattedValue).isSameOrAfter(moment().startOf("day"))) {
          setFormError(prev => ({
            ...prev,
            durationFromDate: "Duration From cannot be a past date.",
          }));
          setPayload(prev => ({ ...prev, durationFromDate: "" }));
          return;
        } else {
          setFormError(prev => ({ ...prev, durationFromDate: "" }));
        }
      }
      if (name === "durationToDate") {
        // Ensure durationToDate is strictly after today (not today)
        if (!moment(formattedValue).isSameOrAfter(moment().startOf("day").add(1, "day"))) {
          setFormError(prev => ({
            ...prev,
            durationToDate: "Duration To must be after today.",
          }));
          setPayload(prev => ({ ...prev, durationToDate: "" }));
          return;
        } else if (fromDate && moment(formattedValue).isBefore(moment(fromDate))) {
          setFormError(prev => ({
            ...prev,
            durationToDate: "Duration To cannot be earlier than Duration From.",
          }));
          setPayload(prev => ({ ...prev, durationToDate: "" }));
          return;
        } else {
          setFormError(prev => ({ ...prev, durationToDate: "" }));
        }
      }
      setPayload(prev => ({
        ...prev,
        [name]: formattedValue,
      }));
      return; // Ensure no other processing happens for these fields
    }
    setPayload(handleFormInput(e, payload));
  };





  const fetchEmployees = async (pageIndex = 0, searchText = "") => {
    setEmployeeLoading(true);
    const payloadData = {
      searchText,
      direction: "desc",
      filterByFieldName: "id",
      companyId: selectedCompanyId,
      pageIndex,
      pageSize: 30,
      employeeList: Array.isArray(payload?.employeeList)
        ? payload.employeeList.map((e) => e.id)
        : [],
    };

    try {
      const response = await getAllEmployee(payloadData);
      if (response?.data?.responseCode === 200) {

        const onlineUsers = response?.data?.responseBody?.employeeResponsePayloadList
          .filter((user) => user?.status === 1 && (!user?.type || user?.type.toLowerCase() === "online"))
          .map((user) => ({ value: user.id, label: user.employeeName }));


        if (pageIndex === 0) setEmployeeOptions(onlineUsers);
        else setEmployeeOptions((prev) => [...prev, ...onlineUsers]);

        setEmployeeHasMore(onlineUsers?.length === payloadData?.pageSize);
      } else if (response?.data?.responseCode === 404) {
        console.log('ok');
        setEmployeeOptions([]);
        // toastEmitter("error",'No user found.');
      } else {
        setEmployeeOptions([]);
        toastEmitter("error", response?.data?.messae);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setEmployeeLoading(false);
    }
  };

  // ---------------- FETCH ASSESSORS ----------------
  const fetchAssessors = async (pageIndex = 0, searchText = "") => {
    setAssessorLoading(true);
    const currentPayload = {
      filterByFieldName: "id",
      direction: "desc",
      pageSize: 10,
      pageIndex,
      searchText,
      companyId: selectedCompanyId,
    };

    try {
      const response = await getAssessorsEmployeeList(currentPayload);
      if (response?.data?.responseCode === 200) {
        const res = response?.data?.data?.companyAssessorResponseList || [];
        console.log('newOptions------------------=', res);

        const newOptions = res
          .filter((o) => o?.status === 1)
          .map((o) => ({ value: o?.id, label: `${o?.adminResponsePayload?.name} (${o?.department?.departmentName} - ${o?.hierarchy?.hierarchyName})` }));

        if (pageIndex === 0) setAssessorOptions(newOptions);
        else setAssessorOptions((prev) => [...prev, ...newOptions]);


        setAssessorHasMore(newOptions?.length === currentPayload?.pageSize);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setAssessorLoading(false);
    }
  };

  // ---------------- INITIAL FETCH ----------------
  useEffect(() => {
    if (selectedCompanyId) {
      fetchEmployees(0, employeeSearchText);
      fetchAssessors(0, assessorSearchText);
    }
  }, [selectedCompanyId]);


  // ---------------- SEARCH HANDLERS ----------------
  useEffect(() => {
    if (selectedCompanyId) {
      setEmployeePageIndex(0);
      fetchEmployees(0, employeeSearchText);
    }
  }, [employeeSearchText, selectedCompanyId]);

  useEffect(() => {
    if (selectedCompanyId) {
      setAssessorPageIndex(0);
      fetchAssessors(0, assessorSearchText);
    }
  }, [assessorSearchText, selectedCompanyId]);

  // ---------------- COMBINE SELECTIONS ----------------
  useEffect(() => {


    const combined = [
      ...selectedEmployees.map((e) => ({
        id: e.id || '', // keep id if it exists
        employeeId: e.value,
        type: "online",
      })),
      ...selectedAssessors.map((a) => ({
        id: a.id || '',
        employeeId: a.value,
        type: "assessor",
      })),
    ];

    setPayload((prev) => ({
      ...prev,
      employeeList: combined,
      companyId: selectedCompanyId,
    }));
  }, [selectedEmployees, selectedAssessors, selectedCompanyId]);






  const [empPayload, setEmpPayload] = useState({
    pageIndex: 0,
    pageSize: 99999,
    searchText: '',
    direction: 'desc',
    filterByFieldName: 'id',
    status: 1,
    campaignId: "",
  });



  // Fetch assigned employees from API
  const getallAssignEmployee = async () => {
    const data = {
      ...empPayload,
      campaignId: EditData?.id,
    };

    try {
      const response = await getAllAssignEmployeesByCampaignId(data);

      if (response?.data?.responseCode === 200) {
        const res = response?.data?.responseBody?.assignEmployeeList || [];





        // Separate employees by type
        const preSelectedEmployees = res
          .filter((emp) => emp?.employeeResponse?.type === "online")
          .map((emp) => ({
            id: emp?.id || "",
            value: emp?.employeeResponse?.id,
            label: emp?.employeeResponse?.employeeName,
          }));


        const preSelectedAssessors = res
          .filter((emp) => emp?.employeeResponse?.type === "assessor")
          .map((emp) => ({
            id: emp?.id || "",
            value: emp?.employeeResponse?.id,
            label: `${emp?.employeeResponse?.employeeName} (${emp?.employeeResponse?.department} - ${emp?.employeeResponse?.hierarchy})`,
          }));

        // 🟢 Employees
        setSelectedEmployees(preSelectedEmployees);
        setAssignedEmployees(preSelectedEmployees);
        setEmployeeOptions((prev) => {
          const merged = [...prev];
          preSelectedEmployees.forEach((emp) => {
            if (!merged.find((e) => e.value === emp.value)) merged.push(emp);
          });
          return merged;
        });

        // 🟢 Assessors
        console.log('preSelectedAssessors', preSelectedAssessors);

        setSelectedAssessors(preSelectedAssessors);
        setAssignedAssessors(preSelectedAssessors);
        setAssessorOptions((prev) => {
          const merged = [...prev];
          preSelectedAssessors.forEach((ass) => {
            if (!merged.find((a) => a.value === ass.value)) merged.push(ass);
          });
          return merged;
        });
      } else if (response?.data?.responseCode === 404) {

      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  // 🧠 Run when edit mode data is available
  useEffect(() => {
    if (EditData?.id) {
      getallAssignEmployee();
    }
  }, [EditData]);


  const handleAdd = async () => {
    setEmployeebtndisable(true);
    setEmployeebtnLoader(true);
    if (
      !payload?.title ||
      !payload?.employeeList ||
      !payload?.durationFromDate ||
      !payload?.durationToDate
    ) {
      toastEmitter("error", "All Fields Required");
      setEmployeebtnLoader(false);
      setEmployeebtndisable(false);
      return;
    }
    const regex = /\s{2,}/g; // Matches two or more consecutive spaces
    if (regex.test(payload?.title)) {
      toastEmitter("error", "Input should not contain multiple consecutive spaces.");
      setEmployeebtnLoader(false);
      setEmployeebtndisable(false);
      return;
    }

    // ✅ Validation for companyColorRequestPayloadList ranges
    const invalidColorRange = payload?.companyColorRequestPayloadList?.some(
      (item) =>
        item.rangeFrom === "" ||
        item.rangeTo === "" ||
        item.rangeFrom == null ||
        item.rangeTo == null
    );

    if (invalidColorRange) {
      toastEmitter("error", "All color range fields (rangeFrom, rangeTo) are required");
      setEmployeebtnLoader(false);
      setEmployeebtndisable(false);
      return;
    }



    try {
      const response = await addEmployeeAssigneAssisment(payload);
      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
        setEmployeebtndisable(false);
        setEmployeebtnLoader(false);

      }
      if (response.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.VIEWASSIGNEDASSESSMENTS);
        setEmployeebtnLoader(false);
        setEmployeebtndisable(false);
        setPayload({
          employeeList: [],
          companyId: "",
          durationFromDate: "",
          durationToDate: ""
        });
        // setSelectOnlineUser([]);
        // setCompanyList([]);
        // setSelectOfflineUser([]);
        // setSelectedOptions([]);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
      setEmployeebtndisable(false);
      setEmployeebtnLoader(false);
    }
  };


  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleNavigateBack = () => {
    navigate(ROUTES.VIEWASSIGNEDASSESSMENTS);
  };






  const getListOfModel = async (status) => {
    try {
      const response = await getAllModels(status);
      if (response?.data?.responseCode === 404) {
        setSelectModelList([]);

      }
      else if (response?.data?.responseCode === 200) {
        const modelOptions = response?.data?.responseBody
          .filter((model) => model.status === 1) // Only include models with status 1
          .map((model) => ({
            value: model.id,
            label: model.modelName,
            Status: model.status,
          }));

        setSelectModelList(modelOptions);
      } else {
        setSelectModelList([]);

      }
    } catch (err) {
    }
  };

  useEffect(() => {
    getListOfModel(0);
  }, []);

  const handleSelectModelId = (e) => {
    setPayload(prev => ({ ...prev, modelId: e.target.value }));
  };

  const handleColorChange = (index, name, value) => {
    const updatedColorList = [...payload.companyColorRequestPayloadList];

    // If rangeTo is being removed, also remove the next rangeFrom
    if (name === "rangeTo" && value === "") {
      updatedColorList[index].rangeTo = "";

      if (index < updatedColorList.length - 1) {
        updatedColorList[index + 1].rangeFrom = "";
      }

      // Clear any previous errors related to rangeTo
      setFormError((prevError) => {
        const newError = { ...prevError };
        delete newError[`rangeTo${index}`];
        return newError;
      });
    } else {
      let cappedValue = Math.min(Number(value), 100);
      updatedColorList[index] = {
        ...updatedColorList[index],
        [name]: cappedValue,
      };

      if (name === "rangeTo") {
        const previousRangeFrom = Number(updatedColorList[index].rangeFrom);
        if (cappedValue <= previousRangeFrom) {
          setFormError((prevError) => ({
            ...prevError,
            [`rangeTo${index}`]: "Range To must be greater than Range From!",
          }));
        } else {
          setFormError((prevError) => {
            const newError = { ...prevError };
            delete newError[`rangeTo${index}`];
            return newError;
          });

          if (index < updatedColorList.length - 1) {
            updatedColorList[index + 1].rangeFrom = cappedValue;
          }
        }
      }
    }
    setPayload({ ...payload, companyColorRequestPayloadList: updatedColorList });
  };

  const handleColorBlur = (index, name, value) => {
    const updatedColorList = [...payload.companyColorRequestPayloadList];
    let cappedValue = Math.min(Number(value), 100);
    // When the user finishes editing the rangeTo field
    if (name === "rangeTo") {
      const previousRangeFrom = Number(updatedColorList[index].rangeFrom);

      if (cappedValue <= previousRangeFrom) {
        setFormError((prevError) => ({
          ...prevError,
          [`rangeTo${index}`]: "Range To must be greater than Range From!",
        }));
      } else {
        setFormError((prevError) => {
          const newError = { ...prevError };
          delete newError[`rangeTo${index}`];
          return newError;
        });

        // Update the next color's rangeFrom if the rangeTo is valid
        if (index < updatedColorList.length - 1) {
          updatedColorList[index + 1].rangeFrom = cappedValue;
        }
      }
    }

    setPayload({ ...payload, companyColorRequestPayloadList: updatedColorList });
  };

  const handleLoadMoreEmployees = () => {


    if (!employeeLoading && employeeHasMore) {
      const nextPage = employeePageIndex + 1;
      setEmployeePageIndex(nextPage);
      fetchEmployees(nextPage, employeeSearchText);
    }
  };


  return (
    <>
      <TableHeading
        className="cursor-pointer"
        firstData="Campaign Management"
        icon={RIGHTARROW_ICON}
        secondData="Campaign Setup"
        iconshow={true}
        // thirdData="Add Campaign Setup"
        thirdData={
          location?.state?.pageType === "Edit"
            ? "Edit Campaign Setup"
            : location?.state?.pageType === "View"
              ? "View Campaign Setup"
              : "Add Campaign Setup"
        }

        onFirstDataClick={handleNavigateBack}
      />
      <div className="container-fluid">
        <div className="caspera_employee_add">
          <div className="row">
            <div className="col-md-4">
              <Inputwithlable
                placeHolder="Enter Title"
                name="title"
                type="text"
                showastrict={true}
                labelName="Enter Title"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={payload?.title}
              />
            </div>
            <div className="col-md-4">
              <DropDownWithLabel
                labelName="Select Company"
                lableclassName="addInput-label"
                name="modelId"
                options={companyList}
                className="form-control addInputText-lable"
                value={payload?.companyId}
                showastrict={true}
                handleSelect={handleSelectCompany}
                disabled={location?.state?.pageType == "Edit"}
              />
            </div>
            <div className="col-md-4">

              <DropDownWithLabel
                labelName="Select Model"
                lableclassName="addInput-label"
                name="modelId"
                options={selectModelList}
                className="form-control addInputText-lable"
                value={payload?.modelId}
                showastrict={true}
                handleSelect={handleSelectModelId}
                disabled={location?.state?.pageType == "Edit"}
              />

            </div>

            <div className="col-md-6">

              <NewMultiSelectDropdown
                labelName="Select Employee"
                options={employeeOptions}
                selectedOptions={selectedEmployees}
                handleChangeSelect={(option) => {
                  if (assignedEmployees.some(e => e.value === option.value)) return;
                  setSelectedEmployees(prev =>
                    prev.some(o => o.value === option.value)
                      ? prev.filter(o => o.value !== option.value)
                      : [...prev, option]
                  );
                }}
                searchText={employeeSearchText}
                setSearchText={setEmployeeSearchText}
                handleLoadMore={handleLoadMoreEmployees}
                hasMore={employeeHasMore}
                loading={employeeLoading}
                showastrict={true}
                moreValue="8"
              />

            </div>
            <div className="col-md-6">

              <NewMultiSelectDropdown
                labelName="Select Assessor"
                options={assessorOptions}
                selectedOptions={selectedAssessors}
                handleChangeSelect={(option) => {
                  if (assignedAssessors.some(a => a.value === option.value)) return;
                  setSelectedAssessors(prev =>
                    prev.some(o => o.value === option.value)
                      ? prev.filter(o => o.value !== option.value)
                      : [...prev, option]
                  );
                }}
                searchText={assessorSearchText}
                setSearchText={setAssessorSearchText}
                handleLoadMore={() => {
                  if (assessorHasMore && !assessorLoading) {
                    const nextPage = assessorPageIndex + 1;
                    setAssessorPageIndex(nextPage);
                    fetchAssessors(nextPage, assessorSearchText);
                  }
                }}
                showastrict={false}
                hasMore={assessorHasMore}
                loading={assessorLoading}
                moreValue="2"
              />
            </div>
            <div className="col-md-6 calander_data">
              <Inputwithlable
                placeHolder="durationFrom"
                name="durationFromDate"
                type="date"
                labelName="Duration From"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={payload?.durationFromDate ? moment(payload?.durationFromDate).format("YYYY-MM-DD") : ""}
                disable={location?.state?.pageType === "Edit" ? true : false}
                max={today}
                showastrict={true}
              />
              <ErrorMsg error={formError?.durationFromDate} />
            </div>
            <div className="col-md-6 calander_data">
              <Inputwithlable
                placeHolder="durationTo"
                name="durationToDate"
                type="date"
                labelName="Duration To"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={payload?.durationToDate ? moment(payload?.durationToDate).format("YYYY-MM-DD") : ""}
                max={today}
                showastrict={true}
              // disable={location?.state?.pageType === "Edit" ? true : false}

              />
              <ErrorMsg error={formError?.durationToDate} />
            </div>
            {payload?.companyColorRequestPayloadList?.map((color, index) => (
              <div className="row" key={index}>
                <div className="col-md-2">
                  <div className="color-container">
                    <p className="d-flex justify-content-center align-items-center rounded colorbox">
                      <span className="me-2" style={{ backgroundColor: color.colorName, width: "100px", height: "15px" }}></span>
                      {/* {color.colorName} */}
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <Inputwithlable
                    placeHolder="RangeFrom"
                    name="rangeFrom"
                    type="number"
                    labelName="Range From"
                    lableclassName="addInput-label"
                    className="form-control addInputText-lable"
                    showastrict={true}
                    value={color.rangeFrom || ""}
                    disable={location?.state?.pageType === "Edit" ? true : false}

                  />
                  <ErrorMsg error={formError?.[`rangeFrom${index}`]} />
                </div>
                <div className="col-md-5">
                  <Inputwithlable
                    placeHolder="RangeTo"
                    name="rangeTo"
                    type="text"
                    labelName="Range To"
                    lableclassName="addInput-label"
                    className="form-control addInputText-lable"
                    value={color.rangeTo || ""}
                    showastrict={true}
                    handleChange={(e) => handleColorChange(index, "rangeTo", e.target.value)}
                    handleBlur={() => handleColorBlur(index, "rangeTo")} // Trigger validation only on blur
                    disable={location?.state?.pageType === "Edit" ? true : false}
                  />
                  <ErrorMsg error={formError?.[`rangeTo${index}`]} />
                </div>
              </div>
            ))}
            <div className="pt-4 d-flex justify-content-center">
              <Loginbtn
                className="submitbtn px-5"
                handleClick={handleAdd}
                type="submit"
                btnName={location?.state?.pageType == "Edit" ? "Update" : "Add"}
                disablebtn={Employeebtndisable}
                loader={EmployeebtnLoader}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAssignedAssesments;
